import React, { useState, useRef } from 'react'
import { Modal, Form } from 'react-bootstrap'
import { CheckBox } from 'devextreme-react/check-box'
import { toast } from 'react-toastify'
import { useParams } from '../../../Providers/ParamsProvider'

const EMPTY_ELEMENT = { name: '', description: '', fileName: '', url: '', isActive: false }

const AddEditHomePageSliderModal = ({ show, onHide, onSaved, editItem }) => {
    const { handleAddHomePageSliderItem, handleUpdateHomePageSliderItem } = useParams()
    const [sliderItem, setSliderItem] = useState(EMPTY_ELEMENT)
    const [errorText, setErrorText] = useState(null)
    const [prevShow, setPrevShow] = useState(false)
    const firstInputRef = useRef(null)

    const isEditMode = !!editItem

    if (show !== prevShow) {
        setPrevShow(show)
        if (show) {
            setSliderItem(editItem ? { ...editItem } : EMPTY_ELEMENT)
            setErrorText(null)
        }
    }

    const validateData = () => {
        if (!sliderItem.name.trim()) {
            setErrorText('Uzupełnij nazwe!')
            return false
        }
        return true
    }

    const handleSave = async () => {
        if (!validateData()) {
            return
        }
        const success = isEditMode
            ? await handleUpdateHomePageSliderItem(sliderItem)
            : await handleAddHomePageSliderItem(sliderItem)

        if (success) {
            toast.success(isEditMode ? 'Zapisano zmiany.' : 'Dodano nową pozycję.')
            setSliderItem(EMPTY_ELEMENT)
            setErrorText(null)
            onSaved?.()
            onHide()
        } else {
            toast.error(isEditMode ? 'Błąd podczas zapisu zmian!' : 'Błąd podczas dodawania pozycji!')
        }
    }

    return (<Modal size='lg' show={show} onHide={onHide} centered onEntered={() => firstInputRef.current?.focus()}>
        <Modal.Header closeButton>
            <Modal.Title>{isEditMode ? 'Edycja pozycji slidera' : 'Dodawanie nowej pozycji slidera'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <div className="row mt-2 align-items-center">
                <div className="col-3"><span>Nazwa:</span></div>
                <div className="col">
                    <Form.Control
                        ref={firstInputRef}
                        name='name'
                        value={sliderItem.name}
                        maxLength={100}
                        onChange={(e) => setSliderItem({ ...sliderItem, name: e.target.value })}
                    />
                </div>
                <div className="col-auto">
                    <span className='error-text-color'>*</span>
                </div>
            </div>
            <div className="row mt-2 align-items-center">
                <div className="col-3"><span>Opis:</span></div>
                <div className="col">
                    <Form.Control
                        name='description'
                        as='textarea'
                        rows={2}
                        value={sliderItem.description ?? ''}
                        maxLength={500}
                        onChange={(e) => setSliderItem({ ...sliderItem, description: e.target.value })}
                    />
                </div>
                <div className="col-auto"><span>&nbsp;</span></div>
            </div>
            <div className="row mt-2 align-items-center">
                <div className="col-3"><span>Nazwa pliku:</span></div>
                <div className="col">
                    <Form.Control
                        name='fileName'
                        value={sliderItem.fileName ?? ''}
                        maxLength={200}
                        onChange={(e) => setSliderItem({ ...sliderItem, fileName: e.target.value })}
                    />
                </div>
                <div className="col-auto"><span>&nbsp;</span></div>
            </div>
            <div className="row mt-2 align-items-center">
                <div className="col-3"><span>URL:</span></div>
                <div className="col">
                    <Form.Control
                        name='url'
                        value={sliderItem.url ?? ''}
                        maxLength={1000}
                        onChange={(e) => setSliderItem({ ...sliderItem, url: e.target.value })}
                    />
                </div>
                <div className="col-auto"><span>&nbsp;</span></div>
            </div>
            <div className="row mt-2 align-items-center">
                <div className="col-auto"><span>Aktywny:</span></div>
                <div className="col">
                    <CheckBox
                        className="custom-checkbox"
                        value={sliderItem.isActive}
                        onValueChanged={(e) => setSliderItem({ ...sliderItem, isActive: e.value })}
                    />
                </div>
            </div>
            <div className={`d-flex justify-content-center mt-3 mb-3`}>
                <span className='error-text-color'>{errorText}</span>
            </div>
            <div className="d-flex flex justify-content-end  mt-4">
                <button className='btn-app-primary me-3' onClick={() => handleSave()}>{isEditMode ? 'Zapisz' : 'Dodaj'}</button>
                <button className='btn-app-secondary' onClick={() => onHide(null)}>Anuluj</button>
            </div>
        </Modal.Body>
    </Modal>)
}

export default AddEditHomePageSliderModal
